import { HStack } from '@talos/kyoko';
import styled from 'styled-components';

/** Vertical separator between tab sections */
export const TabSeparator = styled.div`
  height: 16px;
  width: 1px;
  flex-shrink: 0;
  align-self: center;
  background: ${({ theme }) => theme.borderColorDivider};
`;

/** Wrapper to stretch tabs to full height and position underline at bottom */
export const TabWrapper = styled(HStack)<{ $isSelected?: boolean }>`
  height: 100%;
  align-items: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: ${({ theme, $isSelected }) => ($isSelected ? theme.borderColorTabSelected : 'transparent')};
  }
`;

/** Scrollable container for scenario tabs */
export const ScenarioTabsContainer = styled(HStack)`
  overflow-x: auto;
  flex: 1;
  min-width: 0;
  justify-content: flex-start;
`;

/** Tab bar container with fixed height, background and bottom border */
export const TabBar = styled(HStack)`
  padding-left: ${({ theme }) => theme.spacing12}px;
  padding-right: ${({ theme }) => theme.spacing12}px;
  height: 40px;
  gap: ${({ theme }) => theme.spacing12}px;
  align-items: stretch;
  justify-content: flex-start;
  background: ${({ theme }) => theme.backgroundContent};
  border-bottom: solid 1px ${({ theme }) => theme.backgroundBody};
  overflow: hidden;
`;

/** Container for action buttons that doesn't shrink */
export const ActionButtonsContainer = styled(HStack)`
  flex-shrink: 0;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing8}px;
  align-items: center;
`;

/** Wrapper for scenario chip that doesn't shrink */
export const ScenarioChipContainer = styled(HStack)`
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing4}px;
  align-items: center;
  height: 100%;
`;
